import { Link } from 'react-router-dom';
import { rankings } from '@/mocks/manga';

export default function RankingList() {
  const formatViews = (v: number): string => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  const getRankBadge = (index: number) => {
    if (index === 0) return 'bg-accent-500 text-background-50';
    if (index === 1) return 'bg-accent-400 text-background-50';
    if (index === 2) return 'bg-accent-300 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              人气排行
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网最受欢迎的漫画都在这里</p>
          </div>
          <a
            href="/category/rexue"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            完整榜单
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {rankings.map((manga, index) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all duration-200 group cursor-pointer"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold shrink-0 ${getRankBadge(index)}`}>
                {index + 1}
              </div>
              <img
                src={manga.coverUrl}
                alt={`${manga.title} 封面`}
                className="w-12 h-16 rounded object-cover object-top shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-foreground-900 font-semibold text-sm truncate group-hover:text-primary-500 transition-colors">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{manga.author} · {manga.category}</p>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className={`text-[10px] px-1.5 py-0.5 rounded ${
                    manga.status === '连载中'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {manga.status}
                  </span>
                  <span className="text-[10px] text-foreground-400">
                    <span className="w-3 h-3 inline-flex items-center justify-center">
                      <i className="ri-eye-line text-[9px]"></i>
                    </span>
                    {' '}{formatViews(manga.views)}
                  </span>
                </div>
              </div>
              <div className="text-right shrink-0">
                <div className="flex items-center gap-1 text-accent-500">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                  <span className="text-sm font-bold">{manga.rating}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}